import { ComparisonTable } from '@insurancemenu/imenu-components-lib';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { useQueryParams } from 'global/hooks/useQuery';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useRootStore } from 'store/rootStore';
import { ComparisonPageType } from 'store/ui-stores/comparison/comparisonStore';
import FormsSpinner from 'components/common/general/FormSpinner';
import { createStyles } from './styles';

export interface ComparisonContentProps {
  type: ComparisonPageType;
}

const ComparisonContent = observer(({ type }: ComparisonContentProps): JSX.Element => {
  const classes = createStyles();
  const query = useQueryParams();

  const cartId = query.get('cartId') || null;
  const productLineId = query.get('productLineId') || null;
  const portfolioId = query.get('portfolioId') || null;
  const portfolioIds = query.get('portfolioIds') || null;

  const {
    comparisonStore: {
      loading,
      loaderInPortfolioId,
      filteredPortfolios,
      cart,
      marketingTags,
      productLineAttrs,
      collectInitialData,
      onAddToProposal,
      onRemoveFromProposal,
    },
  } = useRootStore();

  const convertedFilteredPortfolios = filteredPortfolios.map((portfolio) => toJS(portfolio)).slice();
  const convertedMarketingTags = marketingTags.map((tag) => toJS(tag)).slice();
  const convertedProductLineAttrs = productLineAttrs.map((attr) => toJS(attr)).slice();
  const convertedCart = toJS(cart);
  const lastUpdatedShortName = productLineId ? convertedCart.lastUpdateBrowsingCriteria.shortName[productLineId] : '';

  useEffect(() => {
    if (productLineId && cartId) {
      void collectInitialData(cartId, productLineId as ProductLineId, type, portfolioId, portfolioIds || '');
    }
  }, [productLineId, cartId]);

  return (
    <div className={classes.content}>
      <>
        {loading ? (
          <FormsSpinner display={loading} styles={classes.spinnerBg} />
        ) : (
          <>
            {convertedFilteredPortfolios.length > 0 && (
              <ComparisonTable
                containerStyles={classes.tableContent}
                lastUpdateBcShortName={lastUpdatedShortName}
                addButtonTitle="Add To Cart"
                removeButtonTitle="Remove"
                onAddToProposal={onAddToProposal}
                onRemoveFromProposal={onRemoveFromProposal}
                cartItems={convertedCart.cartItems}
                portfolios={convertedFilteredPortfolios}
                marketingTags={convertedMarketingTags}
                productLineAttributes={convertedProductLineAttrs}
                loading={loading}
                productLineId={productLineId ? (productLineId as ProductLineId) : 'GroupDental'}
                loaderInPortfolioId={loaderInPortfolioId}
              />
            )}
          </>
        )}
      </>
    </div>
  );
});

export default ComparisonContent;
